import { Box, styled } from '@mui/material';

const StyledLargeSessionCardTextContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(2)
  }
}));

export default StyledLargeSessionCardTextContainer;
